(function() {
    'use strict';

    Odigeo.UIElements.menu = {};

    Odigeo.UIElements.menu.enhanceMenu = function($el) {
        var _changePage;
        var _changeSelectedMenu;

        $el = !($el instanceof $) ? $($el) : $el;

        if ($el.attr('data-skip-enhance') === 'true') {
            return $el;
        }

        _changeSelectedMenu = function(e, page) {
            Odigeo._.each($el.find('.pa_menu_item'), function(item) {
                $(item).toggleClass('selected', ($(item).find('a').data('href') === page));
            });
        };

        _changePage = function() {
            var target = $(this);
            var link = target.find('a');
            var page = link.data('href');
            var menu = target.closest('.ui_menu');
            var category = menu.data('track-category');
            var action = menu.data('track-action');
            var label = link.data('track-label');
            if (!Odigeo._.isEmpty(page)) {
                Odigeo.trigger('analytics:tracking', {
                    type: 'trackEvent',
                    data: {
                        action: action,
                        category: category,
                        label: label,
                    },
                });
                Odigeo.Router.navigate(page);
            }
        };

        $el.removeClass('hidden');

        $el.off().on(Odigeo.Events.tap, '.pa_menu_item', _changePage);

        $el.attr('data-skip-enhance', true);

        $el.on('changeSelectedMenu', _changeSelectedMenu);

        return $el;
    };
}());
